import { StateToken } from '@ngxs/store';
import { IDashboard, IDashboardWidget } from '@nimbus-dashboard/features/dashboard/model';
import { IWallboardBootstrapResponse } from '../models/wallboard-data.model';

export interface IWallboardStateModel {
  bootstrap: IWallboardBootstrapResponse | null;
  dashboard: IDashboard | null;
  dashboardWidgets: IDashboardWidget[] | null;
  isReloadPending: boolean;
}

export const WallboardStateModelDefault: IWallboardStateModel = {
  bootstrap: null,
  dashboard: null,
  dashboardWidgets: null,
  isReloadPending: false,
};

export const WALLBOARD_STATE_TOKEN = new StateToken<IWallboardStateModel>('wallboard');
